// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { BadgeTypeValues } from "@insite/client-framework/Types/ApiModels";

interface Props {
    productContext: ProductContextModel;
    showTextBadges?: boolean;
    showImageBadges?: boolean;
}

const xngUseWidgetBadges = ({ productContext: { product }, showTextBadges, showImageBadges }: Props) => {
    let imageBadges = [] as any;
    if (showImageBadges && product.badges) {
        imageBadges = product.badges.filter(
            o => o.displayOnBadgeWidget && o.badgeType === BadgeTypeValues.Image && o.largeImageBadgePath,
        );
    }

    // XNG-Change add previouslyPurchased badge
    if(product.properties?.previouslyPurchased?.toLowerCase() === "true" && product.properties.previouslyPurchasedBadge){
        imageBadges?.push(JSON.parse(product.properties.previouslyPurchasedBadge));
    }

    let textBadges = null;
    if (showTextBadges && product.badges) {
        textBadges = product.badges.filter(
            o => o.displayOnBadgeWidget && o.badgeType === BadgeTypeValues.Text && o.displayText,
        );
    }

    return {
        imageBadges,
        textBadges,
    };
};

// eslint-disable-next-line spire/export-styles
export default xngUseWidgetBadges;
